/* Reducers ---------------------------------------------------------------- */
import type { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';

import { isLiveModeEnabled } from 'cadenza/workbook/state/workbook-live-mode-selectors.state';
import type { ViewDataRefreshEvent } from 'cadenza/workbook/state/workbook-live-mode.state';
import type { WorkbookState } from 'cadenza/workbook/workbook.state';

export const liveModeReducers = {
  refreshViewData(state, { payload: { events } }: PayloadAction<{ events: ViewDataRefreshEvent[] }>) {
    state.liveModeLastRefreshTime = Date.now();
    state.liveModeRefreshEvents = events;
  },
  startLiveMode(state) {
    if (isLiveModeEnabled(state)) {
      state.liveModeState = {
        state: 'running',
      };
      state.liveModeLastRefreshTime = Date.now();
    }
  },
  stopLiveMode(state, { payload: silent = true }: PayloadAction<boolean>) {
    state.liveModeState = {
      state: 'stopped',
      silent,
    };
    state.liveModeLastRefreshTime = undefined;
  },
} satisfies SliceCaseReducers<WorkbookState>;
